class ShippingBar {
  constructor() {
    this.container = document.querySelector(".shipping-bar");
    this.progressBar = document.querySelector("#shipping-progress-bar");
    this.messageElement = document.querySelector("#shipping-message");
    this.congratulationsElement = document.querySelector(
      "#shipping-congratulations"
    );
    this.congratulationsTextElement = document.querySelector(
      "#shipping-congratulations-text"
    );

    this.freeShippingThreshold = this.container
      ? parseFloat(this.container.dataset.freeShippingThreshold) / 100
      : 70;
    this.currency = this.container ? this.container.dataset.currency : "£";
    this.missingAmountText = this.container
      ? this.container.dataset.missingAmountText
      : "away from free shipping";
    this.congratulationsText = this.container
      ? this.container.dataset.congratulationsText
      : "Congratulations! You have earned free shipping!";

    this.isInitialized = false;
  }

  init() {
    if (!this.container || !this.progressBar || !this.messageElement) {
      return;
    }

    this.isInitialized = true;
    this.updateProgress();
  }

  async getCurrentCartTotal() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      return cart.total_price / 100;
    } catch (error) {
      console.error("Error fetching cart data:", error);
      return 0;
    }
  }

  formatPrice(price) {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(price);
  }

  calcProgressBar(currentValue, minValue = 0, maxValue) {
    const clampedCurrent = Math.max(minValue, Math.min(currentValue, maxValue));
    const totalRange = maxValue - minValue;
    const currentPosition = clampedCurrent - minValue;
    const percentage =
      totalRange > 0 ? (currentPosition / totalRange) * 100 : 0;
    const remaining = maxValue - clampedCurrent;
    const isComplete = clampedCurrent >= maxValue;

    return {
      percentage: Math.round(percentage * 100) / 100,
      remaining: Math.max(0, remaining),
      isComplete,
    };
  }

  async updateProgress() {
    if (!this.isInitialized) return;

    try {
      const cartTotal = await this.getCurrentCartTotal();
      const progressData = this.calcProgressBar(
        cartTotal,
        0,
        this.freeShippingThreshold
      );

      this.updateProgressBar(progressData.percentage);
      this.updateMessage(progressData);
    } catch (error) {
      console.error("Error updating shipping bar progress:", error);
    }
  }

  updateProgressBar(percentage) {
    if (!this.progressBar) return;

    this.container.classList.add("loading");

    const finalPercentage = Math.min(percentage, 100);
    this.progressBar.style.width = `${finalPercentage}%`;

    setTimeout(() => {
      this.container.classList.remove("loading");
    }, 600);
  }

  updateMessage(progressData) {
    if (
      !this.messageElement ||
      !this.congratulationsElement ||
      !this.congratulationsTextElement
    )
      return;

    if (progressData.isComplete) {
      this.messageElement.style.display = "none";
      this.congratulationsElement.style.display = "block";
      this.congratulationsElement.classList.add("active");
      this.container.setAttribute("data-theme", "success");
      this.congratulationsTextElement.innerHTML = this.congratulationsText;
    } else {
      this.messageElement.style.display = "block";
      this.congratulationsElement.style.display = "none";
      this.congratulationsElement.classList.remove("active");
      this.container.removeAttribute("data-theme");

      const remainingAmount = this.formatPrice(progressData.remaining);
      this.messageElement.innerHTML = `You're only <span class="amount">${remainingAmount}</span> ${this.missingAmountText}`;
    }
  }

  refresh() {
    this.updateProgress();
  }

  updateThreshold(newThreshold) {
    this.freeShippingThreshold = newThreshold;
    this.updateProgress();
  }
}

window.ShippingBar = ShippingBar;

document.addEventListener("DOMContentLoaded", function () {
  const shippingBarElement = document.querySelector(".shipping-bar");
  if (shippingBarElement) {
    const shippingBar = new ShippingBar();
    shippingBar.init();

    window.shippingBarInstance = shippingBar;

    let lastCartTotal = 0;
    setInterval(async () => {
      try {
        const currentTotal = await shippingBar.getCurrentCartTotal();
        if (currentTotal !== lastCartTotal) {
          lastCartTotal = currentTotal;
          shippingBar.refresh();
        }
      } catch (error) {
        console.error("Error polling cart:", error);
      }
    }, 1000);

    if (typeof CartJS !== "undefined") {
      jQuery(document).on("cart.requestComplete", function (event, cart) {
        shippingBar.refresh();
      });

      jQuery(document).on("cart.ready", function (event, cart) {
        shippingBar.refresh();
      });
    }

    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) {
        shippingBar.refresh();
      }
    });

    window.addEventListener("focus", function () {
      shippingBar.refresh();
    });
  }
});
